import { colors } from '@constants/colors';
import { IStyles } from '@interfaces/styles';

export const useStyles = (): IStyles => {
  // const { breakpoints } = useTheme();

  return {
    tooltip: {
      color: colors.white,
      fontSize: '14px',
      fontWeight: '500',
      //backgroundColor: '#0C0B0B',
      backgroundColor: '#1A1A1A99',
      padding: '10px 16px',
      borderRadius: '16px',
    },
    arrow: {
      color: '#1A1A1A99',
    },
  };
};
